import { Platform, TextInput } from 'react-native'
import { styled } from '~/core/styled'

export const Field = styled(TextInput, theme => {
  const outlineWidth =
    Platform.OS === 'web'
      ? {
          outlineWidth: theme.sizingNone,
        }
      : {}
  return {
    base: {
      width: '100%',
      height: theme.sizingMedium,
      flex: 1,
      fontSize: theme.fontSizeThreeandhalfpulse,
      paddingHorizontal: theme.paddingInsetOnepulse,
      paddingVertical: theme.paddingInsetOnepulse,
      fontFamily: theme.fontFamily.regular,
      color: theme.colorTextNeutralAlternative,
      backgroundColor: 'transparent',

      ...outlineWidth,
    },
    variants: {
      size: {
        md: {
          height: theme.sizingExtrasmall,
          fontSize: theme.fontSizeThreepulse,
        },
        ml: {
          height: theme.sizingSmall,
        },
        lg: {
          height: theme.sizingSmall,
        },
        xl: {
          height: theme.sizingSmall,
        },
      },
      isActive: {
        true: {
          color: theme.colorTextNeutralDefault,
        },
      },
      disabled: {
        true: {
          color: theme.colorTextNeutralDisabled,
        },
      },
      readonly: {
        true: {
          color: theme.colorTextNeutralReadonly,
        },
      },
    },
  }
})
